<template>
  <b-modal
    id="modal-ba-penolakan"
    v-model="show"
    title="Finalisasi Berita Acara Penolakan"
    size="md"
    body-class="bg-white"
    cancel-variant="outline-secondary"
    @hidden="resetForm"
  >
    <b-form ref="form" @submit.stop.prevent="handleSubmit" data-vv-scope="form-ba-penolakan">
      <b-row>
        <b-col md="12">
          <b-form-group label="Nomor Berita Acara Penolakan: *" label-for="nomor-ba-penolakan">
            <b-form-input
              id="nomor-ba-penolakan"
              type="text"
              v-model="nomorBAPenolakan"
              v-validate="'required'"
              name="Nomor Berita Acara Penolakan"
              placeholder="Masukkan Nomor BA Penolakan"
              :class="{ 'is-invalid': errors.has('form-ba-penolakan.Nomor Berita Acara Penolakan') }"
            />
            <span class="text-danger" v-if="errors.has('form-ba-penolakan.Nomor Berita Acara Penolakan')">
              {{ errors.first("form-ba-penolakan.Nomor Berita Acara Penolakan") }}
            </span>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>

    <template #modal-footer="{ cancel }">
      <div class="w-100 d-flex justify-content-end gap-2">
        <b-button variant="outline-secondary" class="mr-2" @click="cancel()">
          Batal
        </b-button>
        <b-button variant="primary" @click="handleSubmit">
          <i class="fa fa-floppy-o text-white mr-1" />
          <span class="text-white">Simpan</span>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalBAPenolakan',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    rowData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      nomorBAPenolakan: '',
    }
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  watch: {
    rowData: {
      handler(val) {
        if (val && val.nomor_ba_penolakan) {
          this.nomorBAPenolakan = val.nomor_ba_penolakan
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async handleSubmit() {
      // Validasi vee-validate dengan scope 'form-ba-penolakan'
      const isValid = await this.$validator.validateAll('form-ba-penolakan')
      
      if (!isValid) {
        return
      }

      this.$emit('submit', {
        id: this.rowData?.id,
        nomor_ba_penolakan: this.nomorBAPenolakan,
      })
    },

    resetForm() {
      this.nomorBAPenolakan = ''
      if (this.$validator) {
        this.$validator.errors.clear('form-ba-penolakan')
      }
    },
  },
}
</script>